export default __webpack_public_path__ + "static/media/scrum.741fe396.jpg";